/**
 * Dashboard Module Routes
 *
 * Route definitions for the Dashboard view.
 * Includes the '/' → '/dashboard' redirect.
 */

import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('./views/Dashboard.vue'),
        meta: {
            title: 'Dashboard',
        },
    },
]

export default routes
